import Goal from 'components/framework/models/Goal';
import RecordFields from '../RecordFields';
import { registerRecordFieldsClasses } from './index';

export default class GoalFields extends RecordFields {
  static modelClass = Goal;
}

registerRecordFieldsClasses({ GoalFields: GoalFields });
